import React, { forwardRef, memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { TextField as MuiTextField } from '@material-ui/core'
import { useSectionId } from '@v4/components/common/SectionItem'
import ErrorMessage from '../ErrorMessage'

import useStyles from './TextField.styled'

const TextField = forwardRef(function TextField(props, ref) {
	const {
		layout,
		usePaperColors,
		className,
		InputProps,
		InputLabelProps,
		FormHelperTextProps,
		classes: notUsedClasses,
		...rest
	} = props
	const classes = useStyles(props)
	const InputClasses = (InputProps && InputProps.classes) || {}
	const InputLabelClasses = (InputLabelProps && InputLabelProps.classes) || {}
	const sectionId = useSectionId()

	return (
		<MuiTextField
			fullWidth
			color="secondary"
			{...rest}
			ref={ref}
			className={clsx(className, classes.root, classes[layout])}
			InputProps={{
				...(InputProps || {}),
				id: `${rest.name}-${sectionId}`,
				classes: {
					...InputClasses,
					root: clsx(classes.input, InputClasses.root),
					error: clsx(classes.error, InputClasses.error),
					focused: clsx(classes.focused, InputClasses.focused),
					notchedOutline: clsx(classes.notchedOutline, InputClasses.notchedOutline),
					input: clsx(classes.fieldInput, InputClasses.input),
				},
			}}
			InputLabelProps={{
				...(InputLabelProps || {}),
				htmlFor: `${rest.name}-${sectionId}`,
				classes: {
					...InputLabelClasses,
					root: clsx(classes.label, InputClasses.root),
					error: clsx(classes.error, InputClasses.error),
					focused: clsx(classes.labelFocused, InputClasses.focused),
					shrink: clsx(classes.labelShrank, InputClasses.shrink),
				},
			}}
			FormHelperTextProps={{ component: ErrorMessage, ...FormHelperTextProps }}
		/>
	)
})

TextField.propTypes = {
	className: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		input: PropTypes.string,
		fieldInput: PropTypes.string,
		error: PropTypes.string,
		focused: PropTypes.string,
		notchedOutline: PropTypes.string,
		label: PropTypes.string,
		labelFocused: PropTypes.string,
		labelShrank: PropTypes.string,
		transparent: PropTypes.string,
		light: PropTypes.string,
	}),
	name: PropTypes.string.isRequired,
	value: PropTypes.string,
	usePaperColors: PropTypes.bool,
	label: PropTypes.string,
	required: PropTypes.bool,
	layout: PropTypes.string,
	InputProps: PropTypes.object,
	InputLabelProps: PropTypes.object,
	FormHelperTextProps: PropTypes.object,
	error: PropTypes.bool,
	helperText: PropTypes.string,
	focused: PropTypes.bool,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
}

TextField.defaultProps = {
	layout: 'transparent',
	label: '',
	required: false,
	InputProps: {},
	InputLabelProps: {},
	FormHelperTextProps: {},
}

export default memo(TextField)
